import { api } from '../../services/api';
import type {
  IBot,
  IBotDetalhe,
  ICadastrarBot,
  IResumoMigracao,
  IToken,
  ITokenGerado,
  StatusBot,
  TipoBot,
} from './types';

const BASE = '/api/v1/orquestrador/bots';

interface IEnvelope<T> {
  data: T;
}

export interface IFiltrosBots {
  tipo_bot?: TipoBot;
  status?: StatusBot;
  area?: string;
}

export const listarBots = async (filtros: IFiltrosBots = {}): Promise<IBot[]> => {
  const res = await api.get<IEnvelope<IBot[]>>(`${BASE}/`, { params: filtros });
  return res.data.data;
};

/** Quem já migrou para credencial própria e quem ainda usa o token compartilhado. */
export const obterResumoMigracao = async (): Promise<IResumoMigracao> => {
  const res = await api.get<IEnvelope<IResumoMigracao>>(`${BASE}/migracao`);
  return res.data.data;
};

export const obterBot = async (botName: string): Promise<IBotDetalhe> => {
  const res = await api.get<IEnvelope<IBotDetalhe>>(`${BASE}/${encodeURIComponent(botName)}`);
  return res.data.data;
};

export const cadastrarBot = async (payload: ICadastrarBot): Promise<IBot> => {
  const res = await api.post<IEnvelope<IBot>>(`${BASE}/`, payload);
  return res.data.data;
};

/**
 * Gera a credencial. O `token` em claro vem SÓ nesta resposta — nunca mais.
 * Não persistir em storage, não logar: exibir, deixar copiar e descartar da memória.
 */
export const gerarToken = async (
  tipoBot: TipoBot,
  botName: string,
  descricao?: string,
): Promise<ITokenGerado> => {
  const res = await api.post<IEnvelope<ITokenGerado>>(
    `${BASE}/${tipoBot}/${encodeURIComponent(botName)}/token`,
    { descricao },
  );
  return res.data.data;
};

export const listarTokens = async (
  botName: string,
  incluirRevogados = false,
): Promise<IToken[]> => {
  const res = await api.get<IEnvelope<IToken[]>>(`${BASE}/${encodeURIComponent(botName)}/tokens`, {
    params: { incluir_revogados: incluirRevogados },
  });
  return res.data.data;
};

export const revogarToken = async (tokenId: string): Promise<unknown> => {
  const res = await api.delete<IEnvelope<unknown>>(`${BASE}/tokens/${encodeURIComponent(tokenId)}`);
  return res.data.data;
};
